import Alert                          from '../Components/Alert.ts';
import AlertService                   from '../Services/AlertService.ts';
import DataService                    from '../Services/DataService.ts';
import LoggingService                 from '../Services/LoggingService.ts';
import TabService                     from '../Services/TabService.ts';
//import UpdateCheckoutService          from '../Services/UpdateCheckoutService';
import Action                         from './Action.ts';
//import DataStores                     from '../DataStores';

class UpdateCheckoutAction extends Action {
    private static _underlyingRequest: any = null;

    private static _fragments: any = [];

    private blockUISelector: string;

    /**
     * @param fields
     */
    constructor() {
        super( 'update_order_review' );

       // this.blockUISelector = '#cfw-billing-methods, .cfw-review-pane, #cfw-cart-summary, #cfw-mobile-cart-summary, #cfw-place-order, #cfw-payment-request-buttons, #cfw-mobile-total, .cfw-order-bumps, #cfw-shipping-packages-container, .cfw-next-tab';
        this.blockUISelector = '#ips-billing-methods, .ips-review-pane, #ips-cart-summary, #ips-mobile-cart-summary, #ips-place-order, #ips-payment-request-buttons, #ips-mobile-total, .ips-order-bumps, #ips-shipping-packages-container, .ips-next-tab';
    }

    public load( data: any, args: any = {} ): void {
        this.blockUI( args.block_ui_selector ?? '' );

        console.log("UpdateCheckoutAction is load");

        if ( UpdateCheckoutAction.underlyingRequest !== null ) {
            UpdateCheckoutAction.underlyingRequest.abort();
        }

        const currentTime = new Date();
        const n = currentTime.getTime();
        const url = DataService.getCheckoutParam( 'wc_ajax_url' ).toString().replace( '%%endpoint%%', this.id );

        // ajaxSetup is global, but we use it to ensure JSON is valid once returned.
        jQuery.ajaxSetup( {
            dataFilter( rawResponse, dataType ) {
                let response = rawResponse;

                // We only want to work with JSON
                if ( dataType !== 'json' ) {
                    return rawResponse;
                }

                if ( Action.isValidJSON( response ) ) {
                    return response;
                }
                // Attempt to fix the malformed JSON
                const maybeValidJSON = response.match( /{".*}/ );

                if ( maybeValidJSON === null ) {
                    LoggingService.logError( 'Unable to fix malformed JSON' );
                    LoggingService.logError( 'Response:', response );
                } else if ( Action.isValidJSON( maybeValidJSON[ 0 ] ) ) {
                    LoggingService.logNotice( 'Fixed malformed JSON. Original:', response );
                    // eslint-disable-next-line prefer-destructuring
                    response = maybeValidJSON[ 0 ];
                } else {
                    LoggingService.logError( 'Unable to fix malformed JSON' );
                    LoggingService.logError( 'Response:', response );
                }

                return response;
            },
        } );

        UpdateCheckoutAction.underlyingRequest = jQuery.ajax( {
            type: 'POST',
            url: `${url}&nocache=${n}`,
            data,
            success: this.response.bind( this ),
            error: this.error.bind( this ),
            complete: this.complete.bind( this ),
            dataType: 'json',
            cache: false,
        } );
    }

    public blockUI( selector = '' ): void {
        let { blockUISelector } = this;
        console.log("UpdateCheckoutAction is blocking");

        if ( selector !== '' ) {
            blockUISelector = selector;
        }

        jQuery( blockUISelector ).addClass( 'ips-blocked' );
    }

    public unblockUI(): void {
        jQuery( '.ips-blocked' ).removeClass( 'ips-blocked' );
    }

    /**
     *
     * @param resp
     */
    public response( resp: any ): void {
        if ( typeof resp !== 'object' ) {
            this.error( false, 'Invalid response', 'Server did not return proper JSON response.' );
            return;
        }

        // Prioritize redirect over reload lest we accidentally disable our own cart_edit_empty_cart_redirect setting
        if ( resp.redirect !== false ) {
            window.location = resp.redirect;
            return;
        }

        if ( resp.reload === true ) {
            ( <any>window ).location.reload();
            return;
        }

//! Todo-ips here delete


    }

    static getGatewayDataClass( element: JQuery<HTMLElement> ): string {
        const classes = jQuery( element ).attr( 'class' ).split( ' ' );
        for ( let i = 0; i < classes.length; i++ ) {
            if ( classes[ i ].endsWith( '_data' ) ) {
                return classes[ i ];
            }
        }
        return null; // Return null if no such class exists
    }

    /**
     * @param xhr
     * @param textStatus
     * @param errorThrown
     */
    public error( xhr: any, textStatus: string, errorThrown: string ): void {
        if ( textStatus !== 'abort' ) {
            const alert = new Alert( 'error', DataService.getMessage( 'update_checkout_error' ) );
            AlertService.queueAlert( alert );
            AlertService.showAlerts();
        }

        super.error( xhr, textStatus, errorThrown );
    }

    public complete( xhr: any, textStatus: string ): void {
        // We are treating an aborted request as one that will always have a subsequent request
        if ( textStatus !== 'abort' ) {
            this.unblockUI();
        }
    }

    /**
     * Cleanses our beautiful fragments of evil dirty bad stuff
     */
    static cleanseFragments( value: string ) {
        if ( typeof value !== 'string' ) {
            return value;
        }

        return value.replace( /checked='checked' data-order_button_text/g, 'data-order_button_text' )
            .replace( /reveal-content" style="display:none;">/g, 'reveal-content">' )
            .replace( /ips-radio-reveal-li ips-active/g, 'ips-radio-reveal-li' )
            .replace( /ips-radio-reveal-li ">/g, 'ips-radio-reveal-li">' )
            .replace( /ips-radio-reveal-content" >/g, 'ips-radio-reveal-content">' )
            .replace( /checked='checked'/g, '' )
            .replace( /checked="checked"/g, '' )
            .replace( / /g, '' );
    }

    /**
     * @returns {any}
     */
    static get underlyingRequest(): any {
        return this._underlyingRequest;
    }

    /**
     * @param value
     */
    static set underlyingRequest( value: any ) {
        this._underlyingRequest = value;
    }
}

export default UpdateCheckoutAction;
